export default __webpack_public_path__ + "static/media/team-members.e049840c.png";